import styled from 'styled-components';
import tw from 'twin.macro';
import { StyledSideMenuLink } from 'styles/components/SideMenu.styles';
import { ChevronIcon } from 'styles/components/Icons';

export const StyledAccordion = styled.div`
    ${tw`flex flex-col`}
`;

export const StyledAccordionItems = styled.div`
    ${tw`pr-1 overflow-hidden duration-150 ease-linear transition-max-height`}
`;


export const StyledAccordionLink = styled(StyledSideMenuLink)`
    ${tw`px-4 py-2 mb-1 ml-2 shadow-none`}

    &.active {
        ${tw`ring-1 ring-black ring-opacity-5`}
    }
`;

export const StyledAccordionButton = styled.button`
    ${tw`flex items-center justify-between py-3 pl-4 pr-1 mb-2 text-base rounded-md ring-1 ring-black ring-opacity-5 bg-secondary-light bg-opacity-50 hover:bg-opacity-70 focus:outline-none border border-secondary-light`}

    ${({ active }) => active && tw`shadow-md bg-opacity-5 hover:bg-opacity-20`}
`;

export const StyledAccordionIcon = styled(ChevronIcon)`
    ${tw`h-6 transition-transform duration-150 ease-linear`}

    ${({ active }) => active && tw`transform rotate-90`}
`;